import { render, staticRenderFns } from "./EditAudience.vue?vue&type=template&id=234873f0&scoped=true"
import script from "./EditAudience.vue?vue&type=script&lang=js"
export * from "./EditAudience.vue?vue&type=script&lang=js"
import style0 from "./EditAudience.vue?vue&type=style&index=0&id=234873f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234873f0",
  null
  
)

export default component.exports